import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SITE = "https://alestainnovation.com";

const setAttribute = (selector, attribute, value) => {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
};

// Sets the per-language <head> values (and the <noscript> text). public/index.html holds the
// Turkish defaults; the hreflang alternates stay static there because both pages share them.
// This also runs during the prerender, so the saved /en/ HTML already has the English values.
const PageHead = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    const url = lang === "en" ? `${SITE}/en/` : `${SITE}/`;
    document.documentElement.lang = lang;
    document.title = t("metaTitle");
    setAttribute('meta[name="description"]', "content", t("metaDescription"));
    setAttribute('link[rel="canonical"]', "href", url);
    setAttribute('meta[property="og:url"]', "content", url);
    setAttribute('meta[property="og:title"]', "content", t("metaTitle"));
    setAttribute('meta[property="og:description"]', "content", t("metaDescription"));
    setAttribute('meta[property="og:locale"]', "content", lang === "en" ? "en_US" : "tr_TR");
    const noscript = document.querySelector("body > noscript");
    if (noscript) noscript.textContent = t("noscript");
  }, [lang, t]);

  return null;
};

export default PageHead;
